import { render, staticRenderFns } from "./BcReorder.vue?vue&type=template&id=09060421"
import script from "./BcReorder.vue?vue&type=script&lang=js"
export * from "./BcReorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports